export const explorerSelect = 'itemSelected';
export const spotlightSelect = 'spotlightSelect';
export const windowActionEvent = 'windowActionEvent';